import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@1trading/react/components/ui/select';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { BUSINESS_SIZE_BANDS, EMPLOYEE_BANDS } from '@/constants/institution';
import type { InstitutionBusinessProfileOrDefaults } from '@/features/institution/business-profile/schema';

const InstitutionBusinessProfileFieldsetSize = () => {
  const form = useFormContext<InstitutionBusinessProfileOrDefaults>();
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <FormField
        name="totalAssets"
        control={form.control}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.businessProfile.totalAssets')}*</FormLabel>
            <Select defaultValue={field.value} onValueChange={field.onChange}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder={t('institutionDetails.businessProfile.placeholders.totalAssets')} />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {BUSINESS_SIZE_BANDS.map((band) => (
                  <SelectItem key={band} value={band}>
                    {t(`institutionDetails.businessProfile.businessSizeBands.${band}`)}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        name="annualRevenue"
        control={form.control}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.businessProfile.annualRevenue')}*</FormLabel>
            <Select defaultValue={field.value} onValueChange={field.onChange}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder={t('institutionDetails.businessProfile.placeholders.annualRevenue')} />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {BUSINESS_SIZE_BANDS.map((band) => (
                  <SelectItem key={band} value={band}>
                    {t(`institutionDetails.businessProfile.businessSizeBands.${band}`)}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        name="employees"
        control={form.control}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.businessProfile.employees')}*</FormLabel>
            <Select defaultValue={field.value} onValueChange={field.onChange}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder={t('institutionDetails.businessProfile.placeholders.employees')} />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {EMPLOYEE_BANDS.map((band) => (
                  <SelectItem key={band} value={band}>
                    {t(`institutionDetails.businessProfile.employeeBands.${band}`)}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
InstitutionBusinessProfileFieldsetSize.displayName = 'InstitutionBusinessProfileFieldsetSize';

export { InstitutionBusinessProfileFieldsetSize };
